import { menuSeconds } from "../../constants/menu"
import StallReport from "../../pages/store/report-stall/stallReport"
import StallManage from "../../pages/store/stall-manage/stallManage"
import ZoneManage from "../../pages/store/stall-manage/zoneManage"
import { routeName } from "../routers-name"

const routeStallManage = [
    {
        ...menuSeconds.ZONE_MANAGE,
        key: menuSeconds.ZONE_MANAGE.key,
        name: menuSeconds.ZONE_MANAGE.name,
        textName: menuSeconds.ZONE_MANAGE.textName,
        active: false,
        appBar: true,
        component: ZoneManage
    },
    {
        ...menuSeconds.STALL_REPORT,
        key: menuSeconds.STALL_REPORT.key,
        name: menuSeconds.STALL_REPORT.name,
        textName: menuSeconds.STALL_REPORT.textName,
        path: routeName.stallManage + '/:id',
        active: false,
        appBar: true,
        component: StallManage
    },
]

export default routeStallManage